import { useAuth } from "../context/AuthContext";
import GoldSectionLayout from "../components/GoldSectionLayout";
import GoldDailyPicksPanel from "../components/GoldDailyPicksPanel";

export default function GoldDailyPicksPage() {
  const { token, user } = useAuth();
  return (
    <GoldSectionLayout
      title="Daily Picks"
      subtitle="30 curated picks across every core market — auto-settled overnight."
      testid="gold-daily-picks-page"
    >
      <GoldDailyPicksPanel token={token} isAdmin={!!user?.is_admin} />
    </GoldSectionLayout>
  );
}
